import Button from 'components/ui/button';

/** Falha de carga com "Tentar de novo" (CAT-13, CAT-37). */
export default function ErroDeCarga({ mensagem, onTentarDeNovo }: { mensagem: string; onTentarDeNovo: () => void }) {
  return (
    <div role="alert" className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-xl bg-brand-white px-6 py-5 shadow-jj-01">
      <p className="m-0 text-[13px] text-content">{mensagem}</p>
      <Button variant="solido" size="sm" onClick={onTentarDeNovo}>
        Tentar de novo
      </Button>
    </div>
  );
}
